export default function MySQL_DAYOFMONTH() {
  return (
    <div>
      <h2>MySQL_DAYOFMONTH</h2>    </div>
  );
}